/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import { GenericAgreeStats } from "src/components/Splash/GenericAgreeStats";
import {
  LDBlockDate,
  LDBlockHeading,
  LDBlockParagraph,
  LDBlockSubheading,
} from "src/components/Splash/Layout/Typography";
import { LDBlock } from "src/components/Splash/LDBlock";
import { PostAttrs, PostTemplate } from "src/components/Splash/PostTemplate";
import { AppRoutes } from "src/lib/constants";

export const THE_YEAR_2022_POST_ATTRS: PostAttrs = {
  title: "Some Thoughts on the Internet",
  SEOtitle: "Some Thoughts on the Internet",
  date: "May 10, 2022",
  slug: "the-year-2022",
  description:
    "The internet was supposed to be a giant leap toward techno utopia. It was supposed to be a tool that would allow each of us to peacefully, thoughtfully, and creatively live fulfilling lives. But it has turned out to be nothing more than...",
};

export default function Post() {
  return (
    <PostTemplate leftLink={AppRoutes.Meta} leftLinkText="HOME" rightLink="" rightLinkText="">
      <LDBlock>
        <LDBlockHeading>{THE_YEAR_2022_POST_ATTRS.title}</LDBlockHeading>
        <LDBlockDate>{THE_YEAR_2022_POST_ATTRS.date}</LDBlockDate>
        <LDBlockSubheading>The Year 2022</LDBlockSubheading>
        <LDBlockParagraph>
          The internet was supposed to be a giant leap toward techno utopia. It was supposed to be a tool that
          would allow each of us to peacefully, thoughtfully, and creatively live fulfilling lives. But it has
          turned out to be nothing more than a giant media company.
        </LDBlockParagraph>
        <LDBlockParagraph>
          Almost every aspect of our culture has been commercialized, sanitized, and packaged. Computing, now quite
          far from the escape the 60’s dreamed of, only managed to create a new generation of internet mega corps,
          who in turn invented a new, digital breed of consumerism.
        </LDBlockParagraph>
        <LDBlockParagraph>
          These corporations have near total control over the flow of information in our society. By controlling
          what is posted and consumed, they determine the overall culture, the overall values, and the overall
          truths.
        </LDBlockParagraph>
        <LDBlockParagraph>
          Large internet companies, who already enjoy special access to our government, are trending toward
          something much darker. The end result looks to be that the churning industrial machine that is internet
          technology will merge into the machine of the state at the highest level, and the internet will become
          yet another tool of state control.
        </LDBlockParagraph>
        <LDBlockParagraph>
          Without fundamental changes to everyday life on the internet, we are all destined to become digital
          serfs, <em>continually driven to distraction by the constant assault of form without meaning.</em>
        </LDBlockParagraph>
        <GenericAgreeStats
          title="Some Thoughts on the Internet in 2021"
          buttonText="Agree"
          tableText="Agrees"
          buttonWidth="150px"
        />
      </LDBlock>
    </PostTemplate>
  );
}
